import React from 'react';
import JSONSchemaForm from 'react-jsonschema-form';
import { ImageUploadField } from './ImageUploadField';
import { Button, Card, CardBody } from '../components/Bootstrap';
import { FormProps } from './types';

function ArrayFieldItem({ element }) {
  let moveUpButton;
  if (element.hasMoveUp) {
    moveUpButton = (
      <Button color='success' onClick={element.onReorderClick(element.index, element.index - 1)}>
        Up
      </Button>
    );
  }

  let moveDownButton;
  if (element.hasMoveDown) {
    moveDownButton = (
      <Button color='success' onClick={element.onReorderClick(element.index, element.index + 1)}>
        Down
      </Button>
    );
  }

  return (
    <Card className='lg-vertical-margin'>
      <CardBody>
        <div>{element.children}</div>
        {moveDownButton}
        {moveUpButton}{' '}
        <Button color='danger' onClick={element.onDropIndexClick(element.index)}>
          Delete
        </Button>
      </CardBody>
    </Card>
  );
}

function ArrayFieldTemplate(props) {
  let content;
  if (props.items) {
    content = props.items.map((element) => <ArrayFieldItem key={element.index} element={element} />);
  }

  let addButton;
  if (props.canAdd) {
    addButton = (
      <div>
        <Button color='primary' onClick={props.onAddClick} type='button'>
          Add
        </Button>
      </div>
    );
  }

  return (
    <div className={props.className}>
      <h3>{props.title}</h3>
      {content}
      {addButton}
    </div>
  );
}

function renderFieldRow(prop) {
  const gridSize = prop.content.props.uiSchema.gridSize;
  const className = gridSize ? `col-md-${gridSize}` : 'col-md-12';

  return (
    <div className={className} key={prop.content.key}>
      {prop.content}
    </div>
  );
}

function ObjectFieldTemplate({ TitleField, properties, title, description }) {
  return (
    <div>
      <TitleField title={title} />
      <div className='row'>{properties.map(renderFieldRow)}</div>
      {description}
    </div>
  );
}

export const Form: React.FC<FormProps> = (props) => {
  const { fields, widgets, ...otherProps } = props;

  const fullProps: any = {
    widgets,
    fields: {
      ...fields,
      imageUploadField: ImageUploadField,
    },
    ArrayFieldTemplate,
    ObjectFieldTemplate,
    showErrorList: false,
    ...otherProps,
  };

  return <JSONSchemaForm {...fullProps} />;
};
